
import { Component, Prop, Vue } from 'vue-property-decorator'
import PanelFrame from '@/components/molecules/PanelFrame.vue'
import StudySummaryPanelContent from '@/components/organisms/StudySummaryPanelContent.vue'

/**
 * 学習サマリーパネル
 */
@Component({
  components: {
    PanelFrame,
    StudySummaryPanelContent,
  },
})
export default class StudySummaryPanel extends Vue {
  /** 通常授業学習の通算演習回数 */
  @Prop()
  private countTimesGeneralStudy!: number

  /** 通常授業学習詳細ボタン押下時のイベント */
  @Prop()
  private eventClickGeneralButton!: () => void

  // === N_LMS-282: 講習会トレーニング実装時に以下のコメントアウトを外す ===

  /** 講習会トレーニングの通算演習回数 */
  // @Prop()
  // private countTimesSeminarStudy!: number

  /** 講習会トレーニング詳細ボタン押下時のイベント */
  // @Prop()
  // private eventClickSeminarButton!: () => void

  // === N_LMS-283: 入試直前トレーニング実装時に以下のコメントアウトを外す ===

  /** 入試直前トレーニングの通算演習回数 */
  // @Prop()
  // private countTimesEntranceStudy!: number

  /** 入試直前トレーニング詳細ボタン押下時のイベント */
  // @Prop()
  // private eventClickEntranceButton!: () => void
}
